import {TextButton} from "js/common/views/inputs/buttons";
import React from "react";
import * as Branding from "js/common/branding-constants";
import {Checkbox, FormControlLabel} from "@mui/material";
import * as Auditor from "js/common/auditor";
import {CustomThemeContext} from "js/common/themes/CustomThemeProvider";

const AiAssistantStartOverDialog = ({onStartOver, onCancel}) => {
  const [showThisMessageAgain, setShowThisMessageAgain] = React.useState(true);
  const {theme} = React.useContext(CustomThemeContext);

  const handleCancel = () => {
    localStorage.setItem("showAiAssistantStartOverWarning", showThisMessageAgain.toString());
    if (!showThisMessageAgain) {
      Auditor.audit("ai-assistant-reset-dialog-hidden");
    }
    onCancel();
  };

  const handleStartOver = () => {
    localStorage.setItem("showAiAssistantStartOverWarning", showThisMessageAgain.toString());
    if (!showThisMessageAgain) {
      Auditor.audit("ai-assistant-reset-dialog-hidden");
    }
    onStartOver();
  };

  return <div style={{padding: "1.5rem 0 0.5rem 0", overflow: "hidden", textAlign: "center"}}>

    <svg width="58" height="58" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke="#F59E0B" strokeWidth="2" fill="none" />
      <line x1="12" y1="8" x2="12" y2="12" stroke="#F59E0B" strokeWidth="2" strokeLinecap="round" />
      <circle cx="12" cy="16" r="1" fill="#F59E0B" />
    </svg>

    <p style={{marginTop: "0.5rem", fontSize: "1.2rem", padding: "0 1rem"}}>By starting over, you will lose your current conversation
      with {Branding.aiAssistantName}.<br />
      <strong style={{fontSize: "1rem"}}>Are you sure you want to start over?</strong></p>

    <div style={{display: "flex", justifyContent: "center"}}>
      <FormControlLabel
          control={
            <Checkbox
                checked={!showThisMessageAgain}
                onChange={(e) => setShowThisMessageAgain(!e.target.checked)}
                size="small"
            />
          }
          label="Do not show this message again"
          style={{marginBottom: "1rem", marginTop: "0rem"}}
      />
    </div>

    <div style={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
      <TextButton
          key="ai-startover-modal-cancel"
          style={{
            float: "right",
            marginRight: "1rem",
            marginLeft: "0.5rem",
            backgroundColor: theme.palette.background.paper
          }}
          label={"Cancel"}
          onClick={handleCancel}
      />
      <TextButton
          key="ai-startover-modal-startover"
          type="alert"
          label="Start Over"
          style={{marginLeft: "0.5rem", color: "#fff", marginRight: "0.5rem"}}
          onClick={handleStartOver}
      />
    </div>
  </div>;
};

export default AiAssistantStartOverDialog;